import TagManager from 'react-gtm-module';
import { isAnalyticsAllowed } from './analytics-allowed';

let gtmBootPromise: Promise<void> | null = null;

/** Loads GTM once when analytics are allowed (cookie consent + no GPC opt-out). */
export function bootGtmIfConfigured(): Promise<void> {
    if (!isAnalyticsAllowed()) {
        return Promise.resolve();
    }
    const gtmId = import.meta.env.VITE_GTM_ID;
    if (!gtmId) {
        return Promise.resolve();
    }
    if (!gtmBootPromise) {
        gtmBootPromise = Promise.resolve().then(() => {
            TagManager.initialize({ gtmId });
        });
    }
    return gtmBootPromise;
}
